export const TASK_HISTORY_DEFAULT_DAYS = 30;
export const TASK_HISTORY_MIN_DAYS = 1;
export const TASK_HISTORY_MAX_DAYS = 3650;

export type TaskHistoryPreference = {
  enabled: boolean;
  days: number;
};

export const DEFAULT_TASK_HISTORY_PREFERENCE: TaskHistoryPreference = {
  enabled: false,
  days: TASK_HISTORY_DEFAULT_DAYS,
};

export function readTaskHistoryPreference(value: unknown): TaskHistoryPreference {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return DEFAULT_TASK_HISTORY_PREFERENCE;
  }
  const candidate = value as Partial<TaskHistoryPreference>;
  const days = Number.isInteger(candidate.days)
    && candidate.days! >= TASK_HISTORY_MIN_DAYS
    && candidate.days! <= TASK_HISTORY_MAX_DAYS
    ? candidate.days!
    : TASK_HISTORY_DEFAULT_DAYS;
  return {
    enabled: candidate.enabled === true,
    days,
  };
}

/**
 * Task dates are ISO local calendar dates (YYYY-MM-DD). This keeps the
 * operational history cutoff on that same calendar boundary, rather than
 * comparing a user task date against the VM clock.
 */
export function taskHistoryCutoffDate(today: string, days: number): string {
  const [year, month, day] = today.split("-").map(Number);
  const cutoff = new Date(Date.UTC(year, month - 1, day));
  cutoff.setUTCDate(cutoff.getUTCDate() - days);
  return cutoff.toISOString().slice(0, 10);
}

export function taskHistoryCutoffTimestamp(cutoffDate: string): Date {
  return new Date(`${cutoffDate}T00:00:00.000Z`);
}
